import type { FeeModeEnum, MarketDataSnapshotLevel, OrderIntent, Security, SideEnum } from '@talos/kyoko';
import type { BigSource } from 'big.js';
import type { ClickToTradePreviewOrder } from '../MarketDataCard/types';

export enum LastPriceType {
  LastTraded = 'LastTraded',
  MarketMid = 'MarketMid',
}

export interface OrderBookParams {
  security: Security;
  priceIncrement: string;
  selectedMarkets: string[];
  selectedMarketAccounts: string[];
  showCumQty?: boolean;
  hideLastTraded?: boolean;
  showAllInPrices?: FeeModeEnum | null;
  showFirmLiquidity?: boolean;
  showPriceIncrementSetting?: boolean;
  enableClickToTrade?: boolean;
  clickToTradePreviewOrder: ClickToTradePreviewOrder | undefined;
  onCumQtyClick: (showCumQty: boolean) => void;
  onRowClick: (values: { price: string; side: SideEnum; quantity: string; intent: OrderIntent }) => void;
  onIncrementChange?: (index: number, newIncrement: string) => void;
  onMouseLeaveRow: () => void;
}

export interface OrderBookSnapshotLevel extends MarketDataSnapshotLevel {
  CumQty?: BigSource;
}
